export default __webpack_public_path__ + "static/media/tick-black.4d2a6bcd.svg";